
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { DefaultSeo } from "@components/seo";
import { Analytics } from "@vercel/analytics/react";
import { AnimatePresence, motion, type Variants } from "framer-motion";
import type { AppProps } from "next/app";
import Head from "next/head";
import useTranslation from "next-translate/useTranslation";
import { useEffect } from "react";
import Layout from "../layout/layout";
import "./styles.css";
function CustomApp({ Component, pageProps, router }: AppProps) {
    const { t, lang } = useTranslation("common");
    useEffect(() => {
        if (!(router.isReady && router.query._gl)) {
            return;
        }
        const { _gl: _, ...cleanQuery } = router.query;
        router.replace({ pathname: router.pathname, query: cleanQuery }, undefined, {
            shallow: true,
        });
    }, [router.isReady]);
    const easing = [0.175, 0.85, 0.42, 0.96] as const;
    const textVariants: Variants = {
        enter: {
            opacity: 1,
            transition: { delay: 0.1, duration: 0.25, ease: easing },
            y: 0,
        },
        exit: { opacity: 0, transition: { duration: 0.25, ease: easing }, y: 100 },
    };
    const languages = [
        { href: "https://knswindows.com/", locale: "en", name: "English" },
        { href: "https://knsokna.pl/", locale: "pl", name: "Polski" },
        { href: "https://knsfenster.de/", locale: "de", name: "Deutsch" },
        { href: "https://kns-okna.eu/", locale: "cs", name: "Čeština" },
        { href: "https://knsfinestre.it/", locale: "it", name: "Italiano" },
        { href: "https://knsfenetres.fr/", locale: "fr", name: "Français" },
        { href: "https://knsokna.eu/", locale: "hu", name: "Magyar" },
    ];
    return (<>
      <DefaultSeo openGraph={{
            images: [
                {
                    alt: "Śląska Fabryka Okien KNS. Produkujemy okna przy użyciu najnowszych technologii",
                    height: 630,
                    url: "/ogImage.jpg",
                    width: 1200,
                },
            ],
            locale: lang,
            site_name: "SiteName",
            type: "website",
            // @ts-expect-error
            url: languages.flatMap((item) => item.locale === lang && item.href),
        }} title={t("title")}/>
      <Head>
        <meta content="width=device-width, initial-scale=1" name="viewport"/>
      </Head>
      <Layout>
        <AnimatePresence initial={false} mode="wait">
          <motion.main animate="enter" exit="exit" initial="exit" key={router.route} variants={textVariants}>
            <Component {...pageProps}/>
            <Analytics />
          </motion.main>
        </AnimatePresence>
      </Layout>
    </>);
}
const __Next_Translate__Page__1a1a83a93f1__ = CustomApp;

    export default __appWithI18n(__Next_Translate__Page__1a1a83a93f1__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
    });
  